import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import WhyNaahelCyber from "./components/WhyNaahelCyber/WhyNaahelCyber";
import Steps from "./components/Steps/Steps";
import Reviews from "./components/Reviews/Reviews";
import FAQ from "./components/FAQ/FAQ";
import Pricing from "./components/Pricing/Pricing";
import TrustedBy from "./components/TrustedBy/TrustedBy";
import Footer from "./components/Footer/Footer";
import "./App.css";
import Services from "./components/Services/Services";
import ContactUs from "./components/ContactUs/ContactUs";
import ContactModal from "./components/ContactModal/ContactModal";
import ContactFormMobile from "./components/ContactModal/ContactFormMobile";
import { useDispatch, useSelector } from "react-redux";
import { login } from "./store/authSlice";
import { fetchProducts } from "./store/productsSlice";
import { t } from "./utils/i18n";
import {
  fetchFeatures,
  fetchPlans,
  fetchStatistics,
  fetchTestimonials,
  fetchSteps,
  fetchFaqs,
} from "./store/productDataSlice";

function App() {
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth);
  const { product_code } = useSelector((state) => state.products);
  const lang = localStorage.getItem("naahelcyber-lang");

  useEffect(() => {
    dispatch(login());
    dispatch(fetchProducts());
  }, [dispatch]);

  useEffect(() => {
    if (lang) {
      const title = lang === "ar" ? "ناهل سايبر" : "Naahel Cyber";
      document.title = title;
    }
  }, [lang]);

  useEffect(() => {
    if (access_token && product_code) {
      dispatch(fetchFeatures(product_code));
      dispatch(fetchPlans(product_code));
      dispatch(fetchStatistics(product_code));
      dispatch(fetchTestimonials(product_code));
      dispatch(fetchSteps(product_code));
      dispatch(fetchFaqs(product_code));
    }
  }, [dispatch, access_token, product_code]);

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".reveal"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);


  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App background-wrapper">
              <Header />
              <Hero />
              <div className="reveal fade-up">
                <WhyNaahelCyber />
              </div>
              <div className="reveal fade-up">
                <Services />
              </div>
              <div className="reveal fade-up">
                <Steps />
              </div>
              <div className="reveal fade-up">
                <Reviews />
              </div>
              <div className="reveal fade-up">
                <FAQ />
              </div>
              <div className="reveal fade-up">
                <Pricing />
              </div>

              <div className="reveal fade-up">
                <ContactUs />
              </div>
              <Footer />
              <ContactModal />
            </div>
          }
        />
        <Route path="/contact" element={<ContactFormMobile />} />
      </Routes>
    </Router>
  );
}

export default App;

